import sensors from 'sa-sdk-javascript'

const env = process.env.NODE_ENV
var token = env === 'development' ? '123wieu' : 'Tktt6acg'
var project = env === 'development' ? 'rjhy_huntianling_test' : 'rjhy_wechatall'
var projectId = 'com.baidao.silver'

sensors.init({
  show_log: env === 'development',
  server_url: `https://jc-sensors.9fapi.com/sa?token=${token}&project=${project}`
})

sensors.quick('autoTrack', {
  project_id: projectId,
})

export default sensors
